import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./RealEstateErp.css";

const features = [
  {
    title: "Property Management",
    desc: "Manage listings, pricing, availability, and property details from a centralized dashboard.",
    icon: "🏢",
  },
  {
    title: "Lead & CRM",
    desc: "Track leads, manage follow-ups, and convert prospects into customers efficiently.",
    icon: "📊",
  },
  {
    title: "Inventory Control",
    desc: "Real-time tracking of property availability, bookings, and sales status.",
    icon: "📦",
  },
  {
    title: "Commission System",
    desc: "Automated commission distribution across Director, Broker, and Agent hierarchy.",
    icon: "💰",
  },
  {
    title: "Reports & Analytics",
    desc: "Generate powerful reports and gain insights into business performance.",
    icon: "📈",
  },
  {
    title: "Role-Based Access",
    desc: "Secure system with role-based permissions for all users.",
    icon: "🔐",
  },
];

const RealEstateErp = () => {
  return (
    <div className="erp-section">

      {/* HERO SECTION */}
      <div className="container text-center py-5">
        <motion.h1
          className="erp-heading"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Real Estate ERP
        </motion.h1>

        <p className="erp-sub mt-3">
          A complete solution to manage your real estate business efficiently.
        </p>

        <motion.button
          className="erp-btn mt-4"
          whileHover={{ scale: 1.05 }}
        >
          Request Demo
        </motion.button>
      </div>

      {/* FEATURES */}
      <div className="container pb-5">
        <div className="row g-4">
          {features.map((item, index) => (
            <motion.div
              key={index}
              className="col-md-4"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="feature-card-modern h-100">

                <div className="feature-icon-box">
                  {item.icon}
                </div>

                <h5>{item.title}</h5>
                <p>{item.desc}</p>

              </div>
            </motion.div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default RealEstateErp;